import posthog from "posthog-js";
import type {
  AnalyticsEventName,
  AnalyticsEventPayload,
} from "@imagine/analytics/events";
import { createBrowserAnalyticsClient } from "@imagine/analytics/posthog-browser";
import { env } from "@/wrapper/env";

const apiKey = env.VITE_PUBLIC_POSTHOG_API_KEY;
const host = env.VITE_PUBLIC_POSTHOG_HOST;

if (apiKey) {
  posthog.init(apiKey, {
    api_host: host,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    persistence: "localStorage",
  });
}

export const posthogClient = posthog;

export const analytics = createBrowserAnalyticsClient({
  apiKey,
  host,
  enabled: Boolean(apiKey),
  autocapture: false,
  capturePageview: false,
}).withGlobalProperties({
  env: env.VITE_PUBLIC_ENVIRONMENT,
});

export const trackAnalyticsEvent = async <TName extends AnalyticsEventName>(
  name: TName,
  payload: AnalyticsEventPayload<TName>,
) => {
  await analytics.capture(name, payload);
};
